import { Modal, Space } from 'antd';
import clsx from 'classnames';
import React, { FC, useMemo, useState } from 'react';
import { TdsButton } from '../tds-button';
import './index.scss';
import CloseSvg from './image/close.svg';
import type { ModalProps } from 'antd';

export interface TdsModalProps extends ModalProps {
  okDisabled?: boolean;
  footerDisabled?: boolean;
  onOk?: (() => Promise<void>) | (() => void);
  onCancel?: () => void;
  subtitle?: React.ReactNode;
}

export const TdsModal: FC<TdsModalProps> = (props) => {
  const {
    className,
    children,
    onCancel,
    onOk,
    okDisabled,
    footerDisabled,
    okButtonProps,
    cancelButtonProps,
    okText,
    cancelText,
    title,
    subtitle,
    ...rest
  } = props;
  const [loading, setLoading] = useState(false);

  const onOkClick = async () => {
    setLoading(true);
    try {
      await onOk?.();
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const modalTitle = useMemo(
    () => <>
      {title}
      {subtitle && <div className={'tds-modal-subtitle'}>{subtitle}</div>}
    </>
    , [title, subtitle],
  );

  const modalFooter = useMemo(
    () => (
    <div style={{ display: footerDisabled ? 'none' : 'block' }}>
      <Space>
        <TdsButton onClick={onCancel} {...cancelButtonProps}>
          {cancelText || '取消'}
        </TdsButton>
        <TdsButton
          type="primary"
          loading={loading}
          onClick={onOkClick}
          disabled={okDisabled}
          {...okButtonProps}
        >
          {okText || '确定'}
        </TdsButton>
      </Space>
    </div>)
    , [onCancel, cancelButtonProps, footerDisabled, okText, okDisabled, loading, cancelText, okButtonProps, onOkClick],
  );

  return (
    <Modal
      className={clsx('tds-modal', className)}
      okText="确定"
      cancelText="取消"
      title={modalTitle}
      closeIcon={<img src={CloseSvg} alt={'close'} className='tds-modal-close' />}
      onCancel={onCancel}
      footer={modalFooter}
      {...rest}
    >
      {children}
    </Modal>
  );
};
